import { SavedJobs } from './saved-jobs';
import { SavedJobsProvider } from './saved-jobs.provider';

export const FeatureSavedJobs = () => {
   return (
      <SavedJobsProvider>
         <SavedJobs></SavedJobs>
      </SavedJobsProvider>
   );
};
